import React from 'react'

import { ColorCodeBox, ColorCodeText, ColorCodeWrapper } from '../seatSelector/seatSelector.style'

interface ColorCodeProps {
    color: string
    label: string
}

const ColorCode: React.FC<ColorCodeProps> = ({ color, label }) => (
    <ColorCodeWrapper>
        <ColorCodeBox bgColor={color} />
        <ColorCodeText>{label}</ColorCodeText>
    </ColorCodeWrapper>
)

export default ColorCode
